
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "../public/css/tailwind.css";
import RootApp from "./RootApp";

// Suppress known third-party library console noise
const _origConsoleError = console.error;
console.error = (...args) => {
  const msg = String(args[0] ?? '');
  // @farango/calendar_library internal Vue component crashes on init without profile context
  if (msg.includes("reading 'profile'") || msg.includes('onUpdate-profile')) return;
  _origConsoleError(...args);
};

// Clear stale legacy JWT auth state that doesn't have a Firebase UID/token
try {
  const stored = JSON.parse(localStorage.getItem('auth') || '{}');
  const current = stored?.current || {};
  // Old sessions used cookie JWTs — no _token field. Wipe them.
  if (current && !current._token && current._id && !current.uid) {
    localStorage.removeItem('auth');
    localStorage.removeItem('settings');
  }
} catch (_) {}

const IdurarOs = lazy(() => import('./apps/EcosystemOs'));
ReactDOM.createRoot(document.getElementById("root")).render(
  <RootApp/>
);
